module.exports = __webpack_public_path__ + "media/images/athletes/4140-998c99956cf1ff2597a275422a4d25e2.png";